/**
 * A transcription is linked to exactly one of: an appointment, or a standalone
 * form submission. The whisper API and TranscriptResponse schema both expose
 * these as mutually-exclusive nullable UUIDs — passing both, or stuffing a
 * submission ID into appointmentId, causes the row to be created under the
 * wrong owner and the UI's polling query returns nothing.
 */
export type TranscriptionLink =
  | { appointmentId: string }
  | { formSubmissionId: string }

export function buildTranscriptionLink(
  appointmentId: string | undefined,
  submissionId: string,
): TranscriptionLink {
  return appointmentId
    ? { appointmentId }
    : { formSubmissionId: submissionId }
}
